import React from 'react';
import ReactDOM from 'react-dom';
import {setupStore} from "./store/store";
import ruRU from 'antd/locale/ru_RU';
import {ConfigProvider} from "antd";
import {Router} from "./config/Router";
import {Provider} from "react-redux";
import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey('KEYVERSION=1edencodedsdecodeLiceA');

const store = setupStore();
// @ts-ignore
export const Ext = window.Ext;
// @ts-ignore
ReactDOM.render(<Provider store={store}>
        <ConfigProvider locale={ruRU}>
            <Router/>
        </ConfigProvider>
    </Provider>,
  document.getElementById('root')
);

